
export class Act {
  id: number
  createdAt: Date
  updatedAt: Date
  inspectorId: string
  regionId: string
  districtId: string
  serviceId: number
  actNum: string
  actDate: Date | null
  name: string
  phone: string
  type: string
  description: string | null
  amount: number
  paidAmount: number
  invoiceId: number | null
  invoiceStatus: number | null
  invoiceStatusNote: string | null
  paymentDate: Date | null
  paymentId: number | null
  paymentStatus: number | null
  paymentStatusNote: string | null
  status: string;
  deviceId: string | null

  payments: Payment[]

  static create(data: { [key: string]: any }): Act {
    const model = new Act();

    Object.assign(model, data);

    model.payments = data['payments'].map( payment => {
      return Payment.create(payment);
    })

    return model;
  }

  getStatus() {
    if (this.paidAmount > 0 && this.amount > this.paidAmount) {
      return 'status.Partially paid';
    } else if (this.amount == this.paidAmount) {
      return 'status.Paid';
    } else {
      return 'status.Not paid'
    }
  }
}

export class Payment {
  actId: number;
  paymentId: number;
  paymentDate: Date;
  paymentStatus: number;
  paymentStatusNote: string;
  amount: number;
  paymentType: string;
  invoiceId: number;
  phone: string | null;
  invoiceStatus: number;
  invoiceStatusNote: string;
  inspectorId: string;
  regionId: string;
  districtId: string;
  mtpId: string;

  static create(data: { [key: string]: any }): Payment {
    const model = new Payment();
    Object.assign(model, data);
    return model;
  }

  getPaymentType() {
    switch (this.paymentType) {
      case 'UNDEFINED':
        return 'Неизвестно';
      case 'INVOICE':
        return 'Выставление счета';
      case 'QRCODE':
        return 'Через QR';
      case 'PHONE':
        return 'Оплата по телефону';
      default:
        return 'Неизвестно';
    }
  }
}

export class Mtp {
  id: number;
  name: string;
}

export class District {
  id: number;
  name: string;
  mtps: Mtp[];
}

export class Region {
  id: number;
  name: string;
  districts: District[];
}



// WEBPACK FOOTER //
// D:/Projects/mvdclick/frontend/src/app/models/act.ts